import { Injectable } from '@angular/core';
import { Headers, Response, URLSearchParams, RequestOptions } from '@angular/http';
import {environment} from '../../environments/environment';
import {HttpAuth} from './http-auth.service';
import { Observable } from 'rxjs';
import { Apply } from '../models/apply';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/map';

@Injectable()
export class DocListAnswerService {

  private docUrl: string = `${ environment.apiRoot }/doc-list/`;
  private doclistanswerUrl: string = `${ environment.apiRoot }/doc-apply/`;
  private docAlllistUrl: string = `${ environment.apiRoot }/doc-list-review/`;

  constructor(private http: HttpAuth) {}

  public _subject = new Subject<object>();
  public event = this._subject.asObservable();

  createRequestHeaders(headers: Headers) {
    headers.set('Content-Type', 'application/json');
    headers.set('X-API-KEY', environment.apiKey);
    let userId = localStorage.getItem('id_token');
    if (userId) {
      headers.set('X-ACCESS-TOKEN', userId);
    }
  }

  public getDocList(jobId: string, userId: string): Observable<any> {
    let headers = new Headers();
    const params: URLSearchParams = new URLSearchParams();
    params.append('job_id', String(jobId));
    params.append('user_id', String(userId));
    this.createRequestHeaders(headers);
    const options = new RequestOptions({search: params});

    return this.http.get(this.doclistanswerUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getAllDocList(query:string, page:number): Observable<any> {
    let headers = new Headers();
    const params: URLSearchParams = new URLSearchParams();
    if(query!= ""){
      params.append('query', String(query));
    }
    params.append('page', String(page));
    this.createRequestHeaders(headers);
    const options = new RequestOptions({search: params});

    return this.http.get(this.docAlllistUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public postDocAnswer(doclist_id:string, doc_id:number, docuser_id:number, apply_id:string): Observable<any> {
    let headers = new Headers();
    this.createRequestHeaders(headers);
    let options = {headers: headers};

    let params: URLSearchParams = new URLSearchParams();
    const body = {
      doclist_id:doclist_id,
      doc_id:doc_id,
      docuser_id:docuser_id,
      apply_id:apply_id,
    };

    return this.http.post(this.doclistanswerUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getDoc(): Observable<any> {
    let headers = new Headers();
    this.createRequestHeaders(headers);
    let options = {headers: headers};

    return this.http.get(this.docUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public putDocAnswer(doclist_id:string, doc_id:number, docuser_id:number, apply_id:string): Observable<any> {
    let headers = new Headers();
    this.createRequestHeaders(headers);
    let options = {headers: headers};

    let params: URLSearchParams = new URLSearchParams();
    const body = {
      doclist_id:doclist_id,
      doc_id:doc_id,
      docuser_id:docuser_id,
      apply_id:apply_id,
    };

    return this.http.put(this.doclistanswerUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public putDocAnswerStatus(apply_id:string, doclist_id:string, check:any, comment:any, doc_id:any, docuser_id:any): Observable<any> {
    let headers = new Headers();
    this.createRequestHeaders(headers);
    let options = {headers: headers};

    let params: URLSearchParams = new URLSearchParams();
    const body = {
      check:check,
      comment:comment,
      doc_id:doc_id,
      docuser_id:docuser_id,
      doclist_id:doclist_id,
      apply_id:apply_id,
    };

    return this.http.put(this.doclistanswerUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  //noinspection JSMethodCanBeStatic
  private extractData(res: Response) {
    let body = res.json();
    return body.data || {};
  }

  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/services/doc-list-answer.service.ts